import {getPlatformNameForStats} from "../../../misc/envNameUtils.ts";
import {getIdToken} from "../../../misc/miscUtils.ts";
import {URL_BASE} from "../../../../Globals.ts";

export const updateUserStats = async (user: any, environment: string, vscode: any, stats: any, setDynamicStateObj: any) => {
    const platform = getPlatformNameForStats(environment);
    if (!user || !platform) return;

    try {
        const token = await getIdToken(user);
        const url = `${URL_BASE}/api/updateUserStats`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({
                stats: stats,
                environment: getPlatformNameForStats(environment)
            })
        });

        const data = await response.json();
        const {
            messageCount, hasAskedForReview,
            // hasAskedToCheckoutApps
        } = data;

        if (stats.incrementMessageCount) {
            // if (messageCount > 100 && !hasAskedToCheckoutApps) {
            //     if (platform === "jetbrains") {
            //         window.jetbrainsPostMessage(JSON.stringify({
            //             functionName: "notifyOtherApps",
            //             data: []
            //         }));
            //     } else if (platform === "chrome") {
            //         window.parent.postMessage({
            //             functionName: "notifyOtherApps",
            //             data: []
            //         }, '*');
            //     } else if (platform === "vscode") {
            //         vscode.postMessage({ functionName: "notifyOtherApps", data: [] });
            //     } else if (platform === "web") {
            //         setDynamicStateObj({ visiblePopup: "appsNotification" });
            //     }
            //
            //     updateUserStats(user, environment, vscode, {setHasAskedToCheckoutApps: true}, setDynamicStateObj);
            // }

            if (messageCount > 250 && !hasAskedForReview && platform !== "web") {
                if (platform === "jetbrains") {
                    window.jetbrainsPostMessage(JSON.stringify({
                        functionName: "requestReview",
                        data: []
                    }));
                } else if (platform === "chrome") {
                    window.parent.postMessage({
                        functionName: "requestReview",
                        data: []
                    }, '*');
                } else if (platform === "vscode") {
                    vscode.postMessage({ functionName: "requestReview", data: [] });
                }

                updateUserStats(user, environment, vscode, {setHasAskedForReview: true}, setDynamicStateObj);
            }
        }

    } catch (error) {
        console.error(`Error writing settings: ${error}`);
    }
}
